export default __webpack_public_path__ + "static/media/clear.5f398f9b.svg";